<template>
    <div>   
        <div class="page-header">
            <h3>{{ $t('printabletypes') }}</h3>
            <router-link :to="{name : 'admin.printabletypes.create'}" class="btn btn-success">
                <fa :icon="['fal','plus-circle']" /> {{ $t('add_new_printabletype') }}
            </router-link>
        </div>

        <grid 
            :data="printabletypes"
            :columns="columns"
            v-on:update-data="fetchData"
            v-on:row-clicked="goToEdit"
            edit-route="/admin/printabletypes"
            delete-route="/api/printabletype"
            with-edit
            with-delete></grid>
    </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios";
import Modal from "~/components/Modal";
import Grid from "~/components/Grid";

export default {
    data() {
        return {
            loading: false,
            printabletypes: null,
            error: null,
            columns : [
                { 'col' : 'name','title' : 'Namn'},
                { 'col' : 'description','title' : 'Beskrivning'},
                { 'col' : 'company.name','title' : 'Företag'},
            ]
        };
    },
    components: {
        Modal,
        Grid
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.error = this.printabletypes = null;
            this.loading = true;
            
            axios.get("/api/company").then(response => {
                this.companies = response.data;
            });
            
            axios.get("/api/printabletype").then(response => {
                this.loading = false;
                this.printabletypes = response.data;
            });
        },
        fetchprintabletype(id) {
            this.loading = true;

            axios.get("/api/printabletype/" + id).then(response => {
                this.loading = false;
                this.editprintabletype = id;

                let printabletype = response.data;
                for(var key in printabletype) {
                    if(this.form.hasOwnProperty(key)) {

                        this.form[key] = printabletype[key];
                    }
                }

                $('#printabletype_modal').modal('show');
            });
        },
        goToEdit(entry){
            this.$router.push("/admin/printabletypes/" + entry.id)
        },
        async deleteprintabletype(id) {
            if(confirm(this.$t('delete_printabletype'))){
                const { data } = await this.form.delete("/api/printabletype/" + id);
                this.fetchData();
            }
        },
        async register() {
            // Register the printabletype.
            if(this.editprintabletype){
                const { data } = await this.form.patch("/api/printabletype/" + this.editprintabletype);
            } else {
                const { data } = await this.form.post("/api/printabletype");
            }
            
            $('#printabletype_modal').modal('hide');
            this.editprintabletype = null;
            this.form.reset();
            this.fetchData();
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/printabletypes/index.vue